import React, {useState, useEffect, useContext} from "react";
import {Carousel} from "../../elements/carousel/Carousel";

import './sass/banner.css';
import Apicall from "../../../api/Apicall";
import { Context } from "../context/Context";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router";

export const Banner = () =>{

    const {app, user} = useContext(Context);
    const history = useHistory();

    const  importAll = (r) => {
        const images = {};
        if(r?.keys()) {
            r.keys().map((item,index) => {
                images[item.replace('./','')] = r(item);
                return <></>;
            });
        }
        return images
    }

    const fileImg = require.context('../../../images/banners',true,/\.(png|PNG|jpe?g)$/);
    const imgs = importAll(fileImg);
    const basePath = app.basePathFiles;
    
    const initConfig = {
        id : "idBannerDashBoard",
        width : "16em",
        height : "31.4em",
        indicator : true,
        classIndicatorBtn : "circle-indicator",
        classIndicators : "carousel-cirlce-indicators carousel-indicators-down",
        control : false
    };

    const loading = <div>
            <h3><FormattedMessage id={"general.Loading..."} /></h3>
            <br />
            <div className="spinner-border" role="status">
            </div>
        </div>;
    
    const [config]= useState(initConfig);
    const [data, setData]= useState([ {content : loading }]);

    const param = {
        tipo : 'H',
        ubicacion : 'DSHVTADM'
    };

    useEffect(() => {
        const bannersResult = async ({param}) => {
            try {
                
                const result = await Apicall({
                    url: `${app.url}/dashboard/getBanners`,
                    data: param,user, app
                });
                if(result?.data?.success === false && result.data.banners === undefined){
                    STATIC_EMPTY_BANNER[0].img = imgs[STATIC_EMPTY_BANNER[0].defaultImg];
                    STATIC_EMPTY_BANNER[1].img = imgs[STATIC_EMPTY_BANNER[1].defaultImg];
                    setData(STATIC_EMPTY_BANNER);
                } else if(result?.data?.banners){
                    for(const [index, banner] of Object.entries(result.data.banners)){ 
                        if(banner.img){
                            const nameImg = banner.img.lastIndexOf('/') > 0 ? banner.img.substring(banner.img.lastIndexOf('/')+1) : banner.img;
                            if(imgs?.[nameImg]){
                                if(imgs[nameImg].indexOf("data:image") >= 0){
                                    result.data.banners[index].img = imgs[nameImg];
                                } else {
                                    result.data.banners[index].img = basePath  + imgs[nameImg];
                                }
                            }
                        }
                        if(banner.urlLink){
                            if(banner.target && banner.target !== '_blank'){
                                const link = banner.urlLink;
                                result.data.banners[index].actionBanner = () => {
                                    history.push(link);
                                };
                            } else if(banner.target && banner.target === '_blank'){
                                const link = banner.urlLink;
                                result.data.banners[index].actionBanner = () => {
                                    window.open(link);
                                };
                            
                            }
                        }
                    }
                    setData(result.data.banners)
                } else {
                    setData([]);
                }
            } catch (error) {
                console.log(error)
                return false;
            }
        }
        bannersResult({param : param});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    
    return (
        <>
            <div className="bannerContainer">
                <Carousel config={config} data={data}/>
            </div>
        </>
    );

};


const STATIC_EMPTY_BANNER = [
    {"content" : <div id="prueba1" style={{backgroundColor: "#c1e7f5", height : "100%"}} />,
      "img" : "img.png", "defaultImg" : "img.png"  },
    {"content" : <div id="prueba2" style={{backgroundColor: "#0d6efd", height : "100%"}} />,
    "img" : "img2.png" , "defaultImg" : "img2.png"  }
];